import React, { useEffect } from 'react'
import InnerHaeder from '../Component/InnerHaeder'
import Highlights from '../Component/Highlights'
import Footer from '../Component/Footer'
import { Link } from 'react-router-dom'
import HeadTag from '../Component/HeadTags'
const FeeStructure = () => {


  useEffect(() => {
    // Set the page title
    document.title = 'Fee Structure - Lotus Valley Greater Noida'; // Change 'Your Website Name' to your actual website name
  }, []);

  return (
    <>
      <HeadTag title="Fee Structure" />
      <Highlights />
      <InnerHaeder />
      <div className="inner_page">
        <div className="container-fluid flwidth">
          <div className="bgimage">
            <h5><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link><span> Admission <i className="fas fa-angle-right"></i>  Fee Structure</span></h5>
            <h2>  Fee Structure  (2027-28) </h2>
          </div>
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div class="innertable">
                <table width="100%" cellpadding="0" cellspacing="0">
                  <thead>
                    <tr class="active">
                      <th style={{ width: "50%" }}>ONE- TIME CHARGES (NEW ADMISSIONS ONLY) </th>
                      <th style={{ width: "50%" }}>AMOUNT (Rs.) </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Registration Fee</td>
                      <td>Rs. 1,000 </td>
                    </tr>
                    <tr>
                      <td>Admission Fee  (Non Refundable)</td>
                      <td>Rs. 50,000</td>
                    </tr>
                    <tr>
                      <td>Caution Money (Refundable)</td><td>Rs. 10,000</td>
                    </tr>
                    <tr><td><b>TUITION FEE</b></td><td><b>MONTHLY/QUARTERLY</b></td></tr>
                    <tr><td>NUR - V	</td><td>Rs.10,900/32,700</td></tr>
                    <tr><td>VI-X</td><td>Rs.11,370/34,110</td></tr>
                    <tr><td>XI - COMMERCE & HUMANITIES</td><td>	Rs.12,850/38,550</td></tr>
                    <tr><td>XI - SCIENCE</td><td>	Rs.13,130/39,390</td></tr>
                    <tr><td>XII - COMMERCE & HUMANITIES	</td><td>Rs.12,850/38,550</td></tr>
                    <tr><td>XII -  SCIENCE</td><td>	Rs.13,130/39,390</td></tr>
                    {/* <tr><td><b>TRANSPORT FEE (Optional)</b></td><td><b>MONTHLY/QUARTERLY</b></td></tr>
                    <tr><td>Noida Extension</td><td>Rs.3,300/9,900</td></tr>
                    <tr><td>Noida</td><td>Rs.4,350/13,050</td></tr>
                    <tr><td>Ghaziabad</td><td>	Rs.4,500/13,500</td></tr>
                    <tr><td>Crossing Republik</td><td>	Rs.4,150/12,450</td></tr>
                    <tr><td>Greater Noida</td><td>Rs.4,200/12,600</td></tr> */}
                  </tbody>
                </table>
              </div>

              {/* <div className="border border-dark p-3 mb-3">
                <strong>
                  Mandatory Documents required for the final admission process includes
                  submission of self-attested copy of:
                </strong>

                <br />
                <br />

                1. Birth Certificate
                <br />
                2. Immunization Chart
                <br />
                3. Aadhar Card of the child
                <br />
                4. Aadhar Card of both parents
                <br />
                5. Final Report Card (Grade II upwards)
                <br />
                6. Category Certificate (if applicable)
                <br />
                7. TC Original (Grade II upwards) to be submitted within one month on the
                completion of current academic session
                <br />
                8. PEN (Permanent Education Number)
                <br />
                9. Passport Size Photo (4 photographs each of both parents and child)
                <br />
                10. 02 Passport Size Photo of Guardian apart from parent (maximum details
                of 2 people)
              </div>

              <div className="border border-dark p-3 mb-3">
                <strong>Admission:</strong> 0120-4844771/9821694492/admissions@lotusvalleynoidaextension.com
                <br />
                <strong>Front Desk:</strong> 0120-4844772/8448992087/enquiry@lotusvalleynoidaextension.com
                <br />
                <strong>Website:</strong> www.lotusvalleynoidaextension.com
                <br />
                <strong>Online Registration URL:</strong> www.lviscampuscare.net
              </div> */}

              <div className="border border-dark p-2">
                <strong>
                  <i>
                    The school offers two options for paying the fee, i.e. monthly or
                    quarterly.
                  </i>
                </strong>
              </div>

              {/* <p><b>Note: The school offers two options for paying the fee, i.e. monthly or quarterly.</b></p> */}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default FeeStructure
